/* ReportAction.js */

"use strict";
// const UserGridData = require('@gluenetworks/entity_grid_gl').UserData;
const DEVICE_CUSTOM_FIELDS =
    require("../../views/device_grid_view/deviceConstants").DEVICE_CUSTOM_FIELDS;
const _ = require("lodash");
// const moment = require('moment-timezone');

const OSM_SPECIFIC_FIELDS = ["fileServerName", "vrf", "useIssu", "haPairName"];

const FileName = require("@gluenetworks/steve_utilities").fileName;

class ReportAction {
    constructor(
        reportService,
        userSession,
        logger,
        gameEditor,
        steveIo,
        solutionsManager,
        storageFactory,
        CustomFields,
        ExplorerTemplate
    ) {
        this._reportService = reportService;
        this._userSession = userSession;
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._fileFactory = steveIo.fileFactory;
        this._fileNamer = FileName;
        this._file = steveIo.File;
        this._solutionDefinition = solutionsManager.getActiveSolution();
        this._CustomFieldsEntity = CustomFields;
        this._explorerTemplate = ExplorerTemplate;
        this._devices = _.get(
            this._gameEditor,
            "_activeView._explorerState.selectedIds.selectedRows",
            []
        );
        this._solutionName =
            (solutionsManager.activeSolution && solutionsManager.activeSolution.name) || "";
        this._gridKey = _.camelCase(this._solutionName) + "_" + "deviceExplorer";
        this._userGridData = storageFactory.getRemoteStorageInstanceForEntityGrid(
            "entity_grid_gl",
            this._gridKey
        );
        this._templates = {};

        this.run = this.run.bind(this);
    }

    run() {
        let soln,
            fileNamePrefix,
            reportName,
            workQuery = {};
        const basicSearchData = _.get(this._userGridData.getBasicSearchData(), "filterQuery", {});
        const advancedSearchData = this._userGridData.getAdvancedSearchData() || {};

        switch (this._solutionDefinition.name) {
            case "device_manager":
                fileNamePrefix = "DM";
                reportName = "Device Manager Device List";
                soln = "defaultForDm";
                break;
            case "config_drift":
                fileNamePrefix = "CDA";
                reportName = "Config Drift and Audit Device List";
                soln = "defaultForCda";
                break;
            default:
                fileNamePrefix = "OSM";
                reportName = "Device Manager Device List";
                soln = "defaultForOsm";
        }

        const templateQuery = [];
        const slnQuery = {};
        slnQuery[soln] = {$eq: true};
        templateQuery.push(slnQuery);

        const userId = _.get(this._userSession, "user.id", "");
        const orgId = _.get(this._userSession, "activeOrganization.id", "");

        // const _authedActions = _.get(this._userSession, "authorizedActions", []);

        templateQuery.push({
            tid: {$eq: orgId},
        });
        templateQuery.push({
            ownerId: {$eq: userId},
        });

        if (this._devices.length > 0) {
            workQuery = {
                $and: [{id: {$in: this._devices}}],
            };
        }

        const query = Object.assign(basicSearchData, advancedSearchData, workQuery);
        return this._explorerTemplate
            .loadExplorerTemplates(this._userSession.activeOrganization.id, {
                $and: templateQuery,
            })
            .then((templates) => {
                this._templates = templates;
                const template = templates[0];
                if (template) {
                    // if (_authedActions.indexOf("dataExplorerExploreData") < 0) {
                    //     throw {errorMsg: "Not authorized to run templates."};
                    // }
                    // const _templateName = template.name;
                    // let execution;
                    const workTarget = {
                        method: "query",
                        category: "entity",
                        entityType: "Device",
                        query,
                    };
                    const workInput = {
                        title: `${reportName} Data explorer template execution`,
                        notifyReportTypes: {
                            csv: true,
                            pdf: true,
                            json: true,
                        },
                    };

                    this._gameEditor._modalUserFeedback.displayLoading({
                        message: "Running report...",
                        showHideButton: true,
                    });
                    this._gameEditor._modalUserFeedback.showLoadingProgress("0%");

                    let workCall = "runExploreWork";
                    switch (this._solutionName) {
                        case "device_manager":
                            workCall = "runDmExploreWork";
                            break;
                        case "config_drift":
                            workCall = "runCdaExploreWork";
                            break;
                        case "os_manager":
                            workCall = "runOsmExploreWork";
                            break;
                    }

                    _.invoke(template, workCall, workTarget, workInput, {}, (progress) => {
                        this._logger.info("Explore work progress.. ", progress);
                        const percent = parseInt(
                            (typeof progress.targetCount === "number" && progress.targetCount > 0
                                ? (progress.successCount +
                                      progress.failureCount +
                                      progress.missingTargetCount) /
                                  progress.targetCount
                                : 0) * 100,
                            10
                        );
                        this._gameEditor._modalUserFeedback.showLoadingProgress(`${percent || 0}%`);
                    })
                        .then(() => {
                            return template.loadRelatedExecutions({
                                ownerUserId: _.get(this._userSession, "user.id"),
                                tid: _.get(this._userSession, "activeOrganization.id"),
                            });
                        })
                        .then((exec) => {
                            if (exec.length <= 0) {
                                throw {errorMsg: "Execution failed"};
                            }
                            if (exec[0].status === "FAILED") {
                                this._logger.warn(
                                    {error: exec[0].errorMsg},
                                    "ExportData action - Error"
                                );
                                throw {errorMsg: "Execution failed"};
                            }
                            // execution = exec[0];
                            return exec[0].loadRelatedWork();
                        })
                        .then((work) => work.loadRelatedReports({reportType: "csv"}))
                        .then(async (rep) => {
                            if (!(rep && rep[0])) {
                                throw {errorMsg: "Execution failed :: No report generated"};
                            }
                            this._gameEditor._modalUserFeedback.showLoadingProgress(
                                `Downloading... `
                            );

                            const organizationId = this._userSession.activeOrganization.id;
                            let deviceName = "devices";
                            if (this._devices.length < 2) {
                                const deviceEntity =
                                    await this._gameEditor._DeviceEntityDef.loadDevice(
                                        organizationId,
                                        this._devices[0],
                                        {
                                            name: true,
                                        }
                                    );
                                deviceName = deviceEntity.getName();
                            }

                            const _fileName = this._fileNamer({
                                solution: fileNamePrefix,
                                general: "DeviceReport",
                                specific: deviceName,
                            });
                            this._fileFactory.saveStringAsFile(
                                rep[0].report,
                                _fileName + ".csv",
                                "text/csv"
                            );
                        })
                        .then(() => {
                            this._gameEditor._modalUserFeedback.hideDisplayed();
                        })
                        .catch((err) => {
                            this._logger.warn("Explore work error :: ", err);
                            if (!err.userRejected) {
                                this._gameEditor._modalUserFeedback.hideDisplayed().then(() => {
                                    this._gameEditor._modalUserFeedback.displayError(err);
                                });
                            } else {
                                this._gameEditor._modalUserFeedback.hideDisplayed();
                            }
                        });
                }

                return this._loadCustomFieldsLabelValues().then(async (sortedCustomFields) => {
                    const organizationId = this._userSession.activeOrganization.id;

                    const columnOrder = [].concat(
                        _.map(DEVICE_CUSTOM_FIELDS, "id"),
                        _.map(sortedCustomFields, "value")
                    );
                    let reportParams = {
                        reportName,
                        organizationId,
                        columnOrder: columnOrder,
                        tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
                    };
                    if (!_.isEmpty(query)) {
                        _.set(reportParams, "query", query);
                    }

                    if (!this._gameEditor.isOSMSolutionAvailable) {
                        _.set(reportParams, "columnsHidden", OSM_SPECIFIC_FIELDS);
                    }

                    let deviceName = "devices";
                    if (this._devices.length < 2) {
                        const deviceEntity = await this._gameEditor._DeviceEntityDef.loadDevice(
                            organizationId,
                            this._devices[0],
                            {name: true}
                        );
                        deviceName = deviceEntity.getName();
                    }
                    const _fileName = this._fileNamer({
                        solution: fileNamePrefix,
                        general: "DeviceReport",
                        specific: deviceName,
                    });

                    return Promise.resolve()
                        .then(() => {
                            this._gameEditor._modalUserFeedback.displayLoading({
                                message: "Running report...",
                                showHideButton: true,
                            });
                            return this._reportService.report(reportParams);
                        })
                        .then((result) => {
                            let fileName = _fileName + ".csv";
                            let file = new this._file(fileName, null, result);
                            this._fileFactory.saveFile(file);
                            return this._gameEditor._modalUserFeedback.hideDisplayed();
                        });
                });
            })
            .catch((err) => {
                if (!err.userRejected) {
                    if (this._devices.length === 0) {
                        err.errorMsg = "First select the devices you want to export.";
                        err.errorCode = "";
                    }

                    this._gameEditor._modalUserFeedback.hideDisplayed().then(() => {
                        this._gameEditor._modalUserFeedback.displayError(err);
                    });
                }
            });
    }
    _loadCustomFieldsLabelValues() {
        return this._CustomFieldsEntity
            .loadLabelValues(this._userSession.activeOrganization.id)
            .catch((error) => {
                this._logger.warn({error}, "Can not get Custom Fields definitions");
                return [];
            })
            .then((customFields) =>
                customFields
                    .filter(({systemOwned, enabled}) => !systemOwned && enabled !== false)
                    .sort(this._CustomFieldsEntity.getSortingComparator())
            );
    }
}

module.exports = ReportAction;

ReportAction.$inject = [
    "$teve.services.instance.Report",
    "$teve.userSession",
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.io",
    "$teve.solutionsManager",
    "$teve.storageFactory",
    "$teve.entities.CustomFields",
    "$teve.entities.ExplorerTemplate",
];

ReportAction.$displayDetails = {
    type: "Action",
    name: "ReportAction",
    icon: "configdrift.export_devices",
    shown: true,
    title: "Export devices",
    order: 14,
};
